import React, { useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import ListTable from 'core/components/listTable/ListTable'
import { filterByOperation, numApiResources, parseRoleRules, renderOp } from './helpers'
import RoleAnalysisDialog from './RoleAnalysisDialog'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import DriftResourceSummary from './DriftResourceSummary'
import OperationsPicklistDefault from './OperationsPicklist'
import { allKey } from 'app/constants'

const OperationsPicklist: any = OperationsPicklistDefault

const useStyles = makeStyles((theme: Theme) => ({
  inspectIcon: {
    color: theme.palette.blue[500],
    cursor: 'pointer',
  },
}))

const InspectRoleButton = ({ rbac, role }) => {
  const classes = useStyles({})
  const [dialogOpened, setDialogOpened] = useState(false)

  return (
    <>
      <FontAwesomeIcon className={classes.inspectIcon} onClick={() => setDialogOpened(true)}>
        search-plus
      </FontAwesomeIcon>
      {dialogOpened && (
        <RoleAnalysisDialog rbac={rbac} role={role} onClose={() => setDialogOpened(false)} />
      )}
    </>
  )
}

const renderInspectButton = (rbac, role) => <InspectRoleButton rbac={rbac} role={role} />

const columns = [
  { id: 'op', label: '', render: renderOp },
  { id: 'name', label: 'Name' },
  { id: 'newValue.metadata.namespace', label: 'Namespace' },
  { id: 'numApis', label: 'APIs' },
  { id: 'rbac', label: '', render: renderInspectButton },
]

const RoleAnalysis = ({ roles, isImpactAnalysis, clusterId }) => {
  const [operation, setOperation] = useState(allKey)
  const roleAnalysis = useMemo(
    () =>
      roles.map((role) => {
        const rules = parseRoleRules(role.newValue?.rules)
        return {
          ...role,
          rbac: rules,
          numApis: numApiResources(rules),
          namespace: role.newValue?.metadata?.namespace,
          clusterId,
        }
      }),
    [roles],
  )

  const filteredRoles = filterByOperation(roleAnalysis, operation)

  return (
    <>
      <DriftResourceSummary
        resourceType="Roles"
        resources={roleAnalysis}
        isImpactAnalysis={isImpactAnalysis}
      />
      <div>
        <ListTable
          filters={
            <OperationsPicklist
              onChange={(value) => setOperation(value)}
              value={operation}
              isImpactAnalysis={isImpactAnalysis}
            />
          }
          showCheckboxes={false}
          searchTargets={['name']}
          columns={columns}
          data={filteredRoles}
          rowsPerPage={10}
          uniqueIdentifier="path"
        />
      </div>
    </>
  )
}

export default RoleAnalysis
